import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {AuthTokenService} from '../shared/services/auth-token.service';
import {Router} from '@angular/router';
declare const Swiper: any;

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.less']
})
export class HomeComponent implements OnInit {

  constructor(private router: Router) {
  }

  ngOnInit() {
    const swiper = new Swiper('.swiper', {
        loop: true,
        autoplay: {
          delay: 2000,
        },
        slidesPerView: 'auto'
    });
  }

  onMenuClick(e) {
    document.getElementById("home-header").classList.toggle('burger--active');
  }
}



// WEBPACK FOOTER //
// ./src/app/home/home.component.ts